import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import type { Params } from "@/types";
import type { BirthdayNotificationTemplate } from "@/types/notifications";

const endpoint = {
  notificationsBirthday: "/notifications-birthday",
};

export const fetchNotificationsBirthday = createAsyncThunk(
  "notificationsBirthday/fetch",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.notificationsBirthday, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response?.status === 401) {
          // Silent rejection so UI can wait for session refresh without surfacing error toast
          return thunkAPI.rejectWithValue({
            error: "unauthorized",
            skip: true,
          });
        }
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const createNotificationsBirthday = createAsyncThunk(
  "notificationsBirthday/create",
  async (payload: Omit<BirthdayNotificationTemplate, "id">, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.notificationsBirthday,
        payload,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const updateNotificationsBirthday = createAsyncThunk(
  "notificationsBirthday/update",
  async (
    payload: Partial<BirthdayNotificationTemplate> & { id: number },
    thunkAPI,
  ) => {
    try {
      const { id, ...body } = payload;
      const response = await axiosInstance.put(
        `${endpoint.notificationsBirthday}/${id}`,
        body,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const deleteNotificationsBirthday = createAsyncThunk(
  "notificationsBirthday/delete",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.notificationsBirthday}/${id}`,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error))
        return thunkAPI.rejectWithValue({ error: error.message });
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);
